module.exports = __webpack_public_path__ + "img/logo-1-en.33348c73.png";